import React, { useEffect, useState } from "react";
import Header from "../../components/header/Header";
import PageHeading from "../../components/pageHeading/PageHeading";
import Footer from "../../components/footer/Footer";
import "./booking.scss";

import { LocationIcon } from "../../components/Icons";
import { useLocation } from "react-router-dom";

import { getFullName } from "../../utils/common";
const BookingInfo = () => {
  const location = useLocation();

  return (
    <>
      <Header />
      <PageHeading title="Booking" />
      <div className="main-container">
        <div className="booking-wrapper-main">
          <div className="booking-wrapper">
            <div className="booking-title">Sender Details</div>
            <div className="booking-content-wrap">
              <div className="booking-left">
                {getFullName(
                  location.state?.sender?.firstName,
                  location.state?.sender?.lastName
                )}
              </div>
              <div className="booking-right">
                <div className="icon-wrap">
                  <LocationIcon />
                </div>
                <div className="booking-location-text">
                  {location.state?.sender?.address}
                </div>
              </div>
            </div>
          </div>
          <div className="booking-wrapper">
            <div className="booking-title">Receiver Details</div>
            <div className="booking-content-wrap">
              <div className="booking-left">
                {getFullName(
                  location.state?.receiver?.firstName,
                  location.state?.receiver?.lastName
                )}
              </div>
              <div className="booking-right">
                <div className="icon-wrap">
                  <LocationIcon />
                </div>
                <div className="booking-location-text">
                  {location.state?.receiver?.address}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default BookingInfo;
